import { sdk } from '@/sdk';
import usePurchaseLists from '../usePurchaseLists';

const useWishlist = (storeKey?: string) => {

  const { purchaseLists, mutateAll } = usePurchaseLists();

  const getWishlist = async (id: string) => {
    const result = await sdk.composableCommerce.wishlist.getWishlist({ wishlistId: id });

    if (!result.isError) {
      return { data: result?.data };
    }

    return {};
  };

  const getWishlists = async () => {
    const result = await sdk.composableCommerce.wishlist.queryWishlists({ storeKey, accountId: '' });

    if (!result.isError) {
      return { data: result?.data };
    }

    return { data: [] };
  };

  const addToWishlist = async (wishlistId: string, variant: { sku: string }, count?: number) => {
    const result = await sdk.composableCommerce.wishlist.addItem(
      {
        variant,
        count,
      },
      { id: wishlistId },
    );

    mutateAll();

    if (!result.isError) {
      return { data: result?.data };
    }

    return {};
  };

  return {
    wishlists: purchaseLists,
    getWishlist,
    getWishlists,
    addToWishlist,
  };
};

export default useWishlist;
